import { TenantChildNode } from '@fluentsms/graphql';
import React, { useMemo } from 'react';
import { DrawerAutocompleteOptions, DrawerOptions } from '../base';
import { convertToDrawerOption } from './common';

export const useBranchAutocomplete = (
  companies: TenantChildNode[],
  selectedCompanyId: string,
  selectedBranchId: string,
): DrawerAutocompleteOptions => {
  const branches = useMemo(
    () =>
      (companies.find((company: TenantChildNode) => company.itemId === selectedCompanyId)
        ?.childNodes as TenantChildNode[]) ?? ([] as TenantChildNode[]),
    [companies, selectedCompanyId],
  );

  // Need to make sure the selectedBranchId exists in the array of branches.
  const branchExists = !selectedBranchId && branches.find((branch: TenantChildNode) => branch.id === selectedBranchId);

  const options = useMemo(
    () => [
      ...branches.map((each) => {
        const asDrawerOption = convertToDrawerOption(selectedBranchId)(each);

        return {
          ...asDrawerOption,
          description: <FormattedBranchAbbreviationAndAddress branch={each} />,
        };
      }),
      {
        itemId: '',
        name: '',
        selected: !branchExists,
      },
    ],
    [branches, selectedBranchId],
  );

  const selectedOption = useMemo(
    () =>
      options.find((option: DrawerOptions) => option.selected) ?? {
        itemId: '',
        name: '',
        selected: true,
      },
    [options],
  );

  return {
    options,
    selectedOption,
  };
};

function FormattedBranchAbbreviationAndAddress({ branch }: { branch: TenantChildNode }) {
  return (
    <>
      {branch.abbreviation}
      <br />
      {[branch.address?.address1AndAddress2, branch.address?.cityStateZip].join(', ')}
    </>
  );
}
